import { tracked } from "@supergrain/kernel/react"
import CardStackProvider from "react-app/components/planner/card-stacks/CardStackProvider"
import LessonTitle from "react-app/components/planner/perspectives/month/LessonTitle"

interface Props {
  courseId: string
  planbookId: string
  rotationCalendarId: string
  dateString: string
  /** `weekIndex.courseIndex` — the month grid's row-height bookkeeping key. */
  gridIndex: string
  recalcHeights?: (gridIndex: string) => void
  onLessonFocus?: () => void
}

/** The Ember `Lesson::Provider` + `Month::LessonTitle` pair, as a React island. */
export default tracked(function MonthLessonTitleIsland({
  courseId,
  planbookId,
  rotationCalendarId,
  dateString,
  gridIndex,
  recalcHeights,
  onLessonFocus,
}: Props) {
  return (
    <CardStackProvider
      courseId={courseId}
      planbookId={planbookId}
      rotationCalendarId={rotationCalendarId}
      dateString={dateString}
    >
      {(courseDate, lesson, _units, cardStackIsFulfilled, course, planbook, rotationCalendar) =>
        // date-box.hbs gates the cell on both, inside the block.
        !courseDate.isInsideSchoolYear || !cardStackIsFulfilled || lesson === null ? null : (
          <LessonTitle
            courseDate={courseDate}
            lesson={lesson}
            course={course}
            planbook={planbook}
            rotationCalendar={rotationCalendar}
            dateString={dateString}
            gridIndex={gridIndex}
            recalcHeights={recalcHeights}
            onLessonFocus={onLessonFocus}
          />
        )
      }
    </CardStackProvider>
  )
})
